import React from 'react';
import { connect } from 'react-redux';
import { Offcanvas } from 'react-bootstrap';
import { hideLeftMenu } from '../../../features/offcanvas/offcanvasSlice';
import { Link } from 'react-router-dom';

const LeftSidebar = ({
    hideLeftMenu,
    leftMenuVisible
}) => {
    return (
        <Offcanvas show={leftMenuVisible} onHide={hideLeftMenu} placement="start">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='p-0'>
                <ul class="listview image-listview flush transparent">
                    <li>
                        <Link to="/updates" class="item" onClick={hideLeftMenu}>
                            <div class="icon-box bg-primary">
                                <ion-icon name="albums-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Updates
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/timeline" class="item" onClick={hideLeftMenu}>
                            <div class="icon-box bg-primary">
                                <ion-icon name="hourglass-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Timeline
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/documents" class="item" onClick={hideLeftMenu}>
                            <div class="icon-box bg-primary">
                                <ion-icon name="document-attach-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Documents
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/poll" class="item" onClick={hideLeftMenu}>
                            <div class="icon-box bg-primary">
                                <ion-icon name="analytics-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Polls
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/forms" class="item" onClick={hideLeftMenu}>
                            <div class="icon-box bg-primary">
                                <ion-icon name="document-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Forms
                            </div>
                        </Link>
                    </li>
                    {/* <li>
                        <Link to="/website" class="item" onClick={hideLeftMenu}>
                            <div class="icon-box bg-primary">
                                <ion-icon name="globe-outline"></ion-icon>
                            </div>
                            <div class="in">
                                Website
                            </div>
                        </Link>
                    </li> */}
                </ul>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

const mapStateToProps = ({ offcanvas }) => {
    const { leftMenuVisible } = offcanvas
    return {
        leftMenuVisible
    }
}

const mapDispatchToProps = {
    hideLeftMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftSidebar);